import {
    pureWhite,
    marineColor,
    lightMarineColorShade,
    bluishGrey,
} from '@ui/styles/colors';

export const chatQuestionWrapperStyle = {
    padding         : 0,
    marginBottom    : 16,
    transition      : '.5s all ease',
    transformOrigin : 'top left',
};

export const chatQuestionNameStyle = {
    lineHeight   : 0.9,
    color        : lightMarineColorShade,
    display      : 'block',
    marginBottom : 3,
};

export const chatQuestionListItemTextStyle = {
    marginTop    : 0,
    marginBottom : 0,
    lineHeight   : 1,
};

export const chatQuestionTextWrapperStyle = {
    display                 : 'inline-block',
    marginRight             : 44,
    paddingTop              : 8,
    paddingBottom           : 8,
    paddingRight            : 16,
    paddingLeft             : 16,
    background              : pureWhite,
    borderTopLeftRadius     : 0,
    borderTopRightRadius    : 19,
    borderBottomLeftRadius  : 19,
    borderBottomRightRadius : 19,
    color                   : bluishGrey,
};

export const chatQuestionGrowStyle = {
    transformOrigin: 'bottom left',
};

export const chatQuestionListItemAvatarStyle = {
    display       : 'flex',
    flexDirection : 'row' as 'row',
    alignSelf     : 'flex-start',
    minWidth      : 46,
};

export const chatQuestionAvatarStyle = {
    background: marineColor,
};
